/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NbAuthService, NbAuthOAuth2JWTToken } from '@nebular/auth';
import { NbRoleProvider } from '@nebular/security';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ROLES } from './roles';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleProvider extends NbRoleProvider {

  constructor(private authService: NbAuthService) {
    super();
  }

  getRole(): Observable<string> {

    if (environment.useCookies) {
      return this.getRoleWithCookies();
    }
    return this.getRoleWithToken();
  }
  
  getRoleWithToken(): Observable<string> {
    return this.authService.getToken()
      .pipe(
        map((token: NbAuthOAuth2JWTToken) => {
          const payload = token.getAccessTokenPayload();
          const role = !!(token.isValid() && payload && payload.role) ?
            payload.role.toLowerCase() : 'guest';
          return role;
        }),
      );
  }

  getRoleWithCookies(): Observable<string> {
    const raw = localStorage.getItem('currentUser');

    if (!raw) {
      return of('guest');
    }

    try {
      const currentUser = JSON.parse(raw);
      const role = currentUser?.user?.role;

      return of(role ? role.toLowerCase() : 'guest');
    } catch (e) {
      return of('guest');
    }
  }

  isUser(): Observable<boolean> {
    return this.getRole().pipe(
      map(role => role === ROLES.USER || role === ROLES.HR)
    );
  }

  isAdmin(): Observable<boolean> {
    return this.getRole().pipe(map(role => role === ROLES.ADMIN));
  }

  isHR(): Observable<boolean> {
    return this.getRole().pipe(map(role => role === ROLES.HR));
  }
}
